import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { LogOut, User, Heart } from "lucide-react";
import { useApp } from "../context/AppContext";
import ProductCard from "../components/ProductCard";

export function Account() {
  const { t, lang, user, logout, wishlist } = useApp();
  const navigate = useNavigate();
  if (!user) { navigate("/auth"); return null; }

  return (
    <div className="min-h-[60vh] max-w-[900px] mx-auto px-4 md:px-8 py-16">
      <h1 className="brand-font text-4xl tracking-wide mb-2">{t("myAccount")}</h1>
      <div className="w-10 h-[2px] mb-10" style={{ backgroundColor: "var(--brand)" }} />

      <div className="bg-white border border-neutral-200 p-8 mb-6">
        <div className="flex items-center gap-4 mb-6">
          <div className="w-14 h-14 rounded-full flex items-center justify-center text-white" style={{ backgroundColor: "var(--brand)" }}>
            <User size={24} />
          </div>
          <div>
            <p className="text-lg text-neutral-900">{user.name}</p>
            <p className="text-sm text-neutral-500">{user.email}</p>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <Link to="/wishlist" className="flex items-center gap-3 border border-neutral-200 p-4 hover:border-neutral-400 transition-colors">
            <Heart size={20} style={{ color: "var(--brand)" }} />
            <div>
              <p className="text-sm text-neutral-800">{t("wishlist")}</p>
              <p className="text-xs text-neutral-500">{wishlist.length} {lang === "tr" ? "ürün" : "items"}</p>
            </div>
          </Link>
          <button onClick={() => { logout(); navigate("/"); }} className="flex items-center gap-3 border border-neutral-200 p-4 hover:border-neutral-400 transition-colors text-left">
            <LogOut size={20} className="text-neutral-600" />
            <p className="text-sm text-neutral-800">{t("logout")}</p>
          </button>
        </div>
      </div>
    </div>
  );
}

export default function Wishlist() {
  const { t, products, wishlist } = useApp();
  const items = products.filter((p) => wishlist.includes(p.id));

  return (
    <div className="min-h-[60vh] max-w-[1400px] mx-auto px-4 md:px-8 py-16">
      <h1 className="brand-font text-4xl tracking-wide text-center mb-2">{t("wishlist")}</h1>
      <div className="w-10 h-[2px] mx-auto mb-12" style={{ backgroundColor: "var(--brand)" }} />
      {items.length === 0 ? (
        <div className="text-center py-16">
          <p className="text-neutral-500 mb-6">{t("emptyWishlist")}</p>
          <Link to="/shop" className="inline-block text-white text-xs tracking-widest uppercase px-8 py-3.5" style={{ backgroundColor: "var(--brand)" }}>{t("startShopping")}</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-10 md:gap-x-6">
          {items.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
